import {
  OFFER_TYPE,
  OFFER_STATUS,
  SIGNATURE_STATUS,
  SIGNATURE_TYPE,
  DEFAULT_RATE_MODEL_ID,
} from '@/helpers/constants'

export const process = {
  namespaced: true,
  state: {
    adminDisplay: 'home',
    isProcessStarted: false,
    signStatus: '',
    evaluatorActiveValidations: true,
    pdfFormData: null,
    areProductsPricesValid: true,
    isPaymentFormValid: true,
    isPackagesFormValid: true,
    isDispersionFormValid: true,
    offerTypeByValidations: {
      productPrices: OFFER_TYPE.A,
      productWeights: OFFER_TYPE.A,
      additionalServices: OFFER_TYPE.A,
      paymentMethods: OFFER_TYPE.A,
      products: OFFER_TYPE.A,
    },
    pdfPagesPerSection: {},
    pdfTotalPages: 0,
    showEditValidatedOfferDialog: false,
    rateModelIdOnOfferLoad: DEFAULT_RATE_MODEL_ID,
  },
  mutations: {
    setAdminDisplay: (state, section) => {
      state.adminDisplay = section
    },
    setIsProcessStarted: (state, started) => {
      state.isProcessStarted = started
    },
    setSignStatus: (state, payload) => {
      const {
        status,
        contract: { events, status: contractStatus, signatureType },
      } = payload

      if (events.length === 0 || signatureType === SIGNATURE_TYPE.MANUAL) {
        state.signStatus = contractStatus
      } else if (status === OFFER_STATUS.SIGNED) {
        // NOTE: force this signStatus because Signaturit can send further events
        // (e.g. "email_processed") after "document_completed" or "audit_trail_completed"
        state.signStatus = SIGNATURE_STATUS.DOCUMENT_COMPLETED
      } else {
        state.signStatus = events[events.length - 1].type
      }
    },
    setEvaluatorActiveValidations: (state, active) => {
      state.evaluatorActiveValidations = active
    },
    setPdfFormData: (state, data) => {
      state.pdfFormData = data
    },
    setAreProductsPricesValid: (state, valid) => {
      state.areProductsPricesValid = valid
    },
    setIsPaymentFormValid: (state, valid) => {
      state.isPaymentFormValid = valid
    },
    setIsPackagesFormValid: (state, valid) => {
      state.isPackagesFormValid = valid
    },
    setIsDispersionFormValid: (state, valid) => {
      state.isDispersionFormValid = valid
    },
    setOfferTypeByValidations: (state, data) => {
      state.offerTypeByValidations = data
    },
    setPdfSectionPages: (state, data) => {
      state.pdfPagesPerSection = { ...state.pdfPagesPerSection, ...data }

      state.pdfTotalPages = Object.values(state.pdfPagesPerSection).reduce(
        (acc, pages) => acc + pages,
        0,
      )
    },
    setShowEditValidatedOfferDialog: (state, show = true) => {
      state.showEditValidatedOfferDialog = show
    },
    setRateModelIdOnOfferLoad: (state, rateModelId) => {
      state.rateModelIdOnOfferLoad = rateModelId
    },
    resetTypeBFormsValidation: state => {
      state.isPackagesFormValid = true
      state.isDispersionFormValid = true
    },
  },
  getters: {
    isStep1ReadOnly: (state, _, rootState) =>
      rootState.offer.offer.status !== OFFER_STATUS.CREATED &&
      state.rateModelIdOnOfferLoad !== DEFAULT_RATE_MODEL_ID,
    isOfferValid: state =>
      state.areProductsPricesValid &&
      state.isPaymentFormValid &&
      state.isPackagesFormValid &&
      state.isDispersionFormValid,
  },
}
